import { render, staticRenderFns } from "./Panitia.vue?vue&type=template&id=39620ed4&scoped=true"
import script from "./Panitia.vue?vue&type=script&lang=js"
export * from "./Panitia.vue?vue&type=script&lang=js"
import style0 from "./Panitia.vue?vue&type=style&index=0&id=39620ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39620ed4",
  null
  
)

export default component.exports